module.exports = __webpack_public_path__ + "img/a208758e12016fc10e8a79811c08f892.png";